module.exports = __webpack_public_path__ + "static/media/Linkedin.f856d3e2.png";